<template>
    <div class="ui">
      <transition name="fade">
           <leave-alert :close="closePop" v-if="popUpToggle"></leave-alert>
       </transition>
       <div id="mobile-progress-bar"><div :style="{width: progressValue}"></div></div>
        <div id="close-btn" @click="popLeaveAlert()"><div></div><div></div></div>
        <section class="container">
            <div class="form-container">
               <banner></banner>
<!--                <forms :formStep="formStep" @checkFormOnChange="changeProgressPercentage()"></forms>-->
               <forms :formStep="formStep"></forms>
            </div>
            <div class="step-container">
                <div id="mobile-step">
                    <div>
<!--                       <div class="mobile-current-step" v-bind:class="{active: showMobileStepList}" @click="showMobileStepList = !showMobileStepList">-->
                        <div class="mobile-current-step" @click="mobileStepListClick" v-bind:class="{active: showMobileStepList}">
                            <img src="../assets/step1-icon.svg" alt="" v-if="formStep === 0">
                            <img src="../assets/step2-icon.svg" alt="" v-if="formStep === 1">
                            <img src="../assets/step3-icon.svg" alt="" v-if="formStep === 2">
                            <img src="../assets/step4-icon.svg" alt="" v-if="formStep === 3">
                        </div>
                        <div class="mobile-step-list-container">
                            <div class="step-item" @click="scrollToStep('form-one')" :class="{'valid': formStep >= 0, 'active': formStep === 0}"><img src="../assets/step1-icon.svg" alt=""><span>個人資料</span></div>
                            <div class="step-item" @click="scrollToStep('form-two')" :class="{'valid': formStep >= 1, 'active': formStep === 1}"><img src="../assets/step2-icon.svg" alt=""><span>職業及銀行資料</span></div>
                            <div class="step-item" @click="scrollToStep('form-three')" :class="{'valid': formStep >= 2, 'active': formStep === 2}"><img src="../assets/step3-icon.svg" alt=""><span>投資者背景及交易經驗</span></div>
                            <div class="step-item" @click="scrollToStep('form-four')" :class="{'valid': formStep >= 3, 'active': formStep === 3}"><img src="../assets/step4-icon.svg" alt=""><span>確認申請及條款</span></div>
                            <div id="mobile-step-list-cancel-bg" @click="mobileStepListClick"></div>
                        </div>
                    </div>
                </div>
                <div id="normal-step">
                    <div>
                       <div id="normal-step-progress" :style="{height: progressValue}"></div>
                        <div class="step-item" @click="scrollToStep('form-one')" :class="{'valid': formStep >= 0}"><img src="../assets/step1-icon.svg" alt=""><span>個人資料</span></div>
                        <div class="step-item" @click="scrollToStep('form-two')" :class="{'valid': formStep >= 1}"><img src="../assets/step2-icon.svg" alt=""><span>職業及銀行資料</span></div>
                        <div class="step-item" @click="scrollToStep('form-three')" :class="{'valid': formStep >= 2}"><img src="../assets/step3-icon.svg" alt=""><span>投資者背景及交易經驗</span></div>
                        <div class="step-item" @click="scrollToStep('form-four')" :class="{'valid': formStep >= 3}"><img src="../assets/step4-icon.svg" alt=""><span>確認申請及條款</span></div>
                    </div>
                </div>
                <div id="next-btn" @click="checkSubmit()" :style="{background: nextBtnBgValue}">{{nextBtnTextValue}}</div>
            </div>
        </section>
    </div>
</template>


<script>
    import banner from "./banner.vue";
    import formsGather from "./formsGather.vue";
    import leaveAlert from "./leaveAlert.vue";
    export default {
        inherit: true,
        inject: ['$validator'],
        name: "ui",
        components: {
            "banner": banner,
            "forms": formsGather,
            "leave-alert": leaveAlert
        },
        data: () => ({
            showMobileStepList: false,
            formStep: 0,
            progressValue: "12.5px",
            nextBtnBgValue: "#4D4D4D",
            nextBtnTextValue: "下一步＞",
            submitted: false,
            popUpToggle: false
        }),
        computed: {},
        methods: {
            popLeaveAlert(){
                this.popUpToggle = !this.popUpToggle;
            },
            closePop(){
                this.popUpToggle = false;
            },
            mobileStepListClick(){
                this.showMobileStepList = !this.showMobileStepList;
            },
            checkSubmit(){
                this.$validator.validateAll("signup_agent_form").then((result) => {
                    var self = this;
//                    console.log(Object.keys(this.fields.$signup_agent_form).length);
//                    console.log(this.errors.items.length);
//                    console.log(this.$el.querySelectorAll(`#form-one [data-vv-as]:not([data-vv-as=''])`).length);
                    if(result){
                        this.formStep++;
                        switch(this.formStep){
                            case 1:
                                setTimeout(function(){
                                    self.nextBtnBg(1);
                                    self.nextBtnText(0);
                                    self.$el.querySelector("#form-two").scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
                                },500);
                                break;
                            case 2:
                                setTimeout(function(){
                                    self.nextBtnBg(1);
                                    self.nextBtnText(0);
                                    self.$el.querySelector("#form-three").scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
                                },500);
                                break;
                            case 3:
                                setTimeout(function(){
                                    self.nextBtnBg(1);
                                    self.nextBtnText(2);
                                    self.$el.querySelector("#form-four").scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
                                },500);
                                break;
                            case 4:
                                /* pass all, submit */
                                self.$el.querySelector("#form").submit();
                                break;
                               }
                        return;
                    }
                    if(this.$el.querySelector('[name="' + this.$validator.errors.items[0].field + '"]')){
                        this.$el.querySelector('[name="' + this.$validator.errors.items[0].field + '"]').parentElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
//                        console.log('[name="' + this.$validator.errors.items[0].field + '"]');
                        setTimeout(function(){
                            self.$el.querySelector('[name="' + self.$validator.errors.items[0].field + '"]').focus();
                        },500);
                    }
                    else if(this.$el.querySelector('[data-vv-name="' + this.$validator.errors.items[0].field + '"]')){
                        this.$el.querySelector('[data-vv-name="' + this.$validator.errors.items[0].field + '"]').parentElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
//                        console.log('[data-vv-name="' + this.$validator.errors.items[0].field + '"]');
                        setTimeout(function(){
                            self.$el.querySelector('[data-vv-name="' + self.$validator.errors.items[0].field + '"]').focus();
                        },500);
                    }
                    this.submitted = true;
                    this.nextBtnBg(2);
                    this.nextBtnText(1);
                });
            },
            scrollToStep(id){
                if(this.$el.querySelector(`#${id}`)){
                    this.$el.querySelector(`#${id}`).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
                    if(this.showMobileStepList){
                        this.showMobileStepList = !this.showMobileStepList;
                    }
                }
            },
            changeProgressPercentage(){
                var self = this;
                var obj = this.fields.$signup_agent_form;
                var objLength = Object.keys(obj).length;
                var checkValidAmount = 0;
                Object.keys(obj).forEach(function(key){
                    if(obj[key].valid){
                        checkValidAmount++
                    }
                });
                this.progressPercentage();
//                console.log(`Amount of fields: ${objLength}, Amount of valid: ${checkValidAmount}`);
                if(objLength == checkValidAmount){
//                    console.log("changeProgressPercentage return valid");
                    this.submitted = false;
                    this.nextBtnBg(0);
                    if(this.formStep > 2){
                        this.nextBtnText(2);
                    }else{
                        this.nextBtnText(0);
                    }
                }else if(objLength !== checkValidAmount){
                    this.nextBtnBg(1);
                }
                switch(this.formStep){
                    case 0:
                        break;
                    case 1:
                        break;
                    case 2:
                        break;
                    case 3:
                        break;
                    case 4:
                        break;
                }
                setTimeout(function(){
                    self.changeProgressPercentage();
                },500);
            },
            nextBtnBg(pass){
                /* pass: [0(valid),1(normal),2(invalid warn)], triggleType: ["native"(from change any event), "submit"(clicked next btn)] */
                if(this.submitted === true){
//                    console.log("nextBtnBG submitted");
                    if(pass == 2){
                        this.nextBtnBgValue = "#FF1A1A";
                    }
                    else if(pass == 0){
                        this.nextBtnBgValue = "#33DB40";
                    }
                }else if(this.submitted === false){
//                    console.log("nextBtnBG not submitted");
                    if(pass == 1){
                        this.nextBtnBgValue = "#4D4D4D";
                    }
                    else if(pass == 0){
                        this.nextBtnBgValue = "#33DB40";
                    }
                }
            },
            nextBtnText(pass){
                switch(pass){
                    case 0:
                        this.nextBtnTextValue = "下一步＞";
                        break;
                    case 1:
                        this.nextBtnTextValue = "請填寫所需信息";
                        break;
                    case 2:
                        this.nextBtnTextValue = "提交申請";
                        break;
                }
            },
            progressPercentage(){
                var obj = this.fields.$signup_agent_form;
                var objLength = Object.keys(obj).length;
                var checkValidAmount = 0;
                Object.keys(obj).forEach(function(key){
                    if(obj[key].valid){
                        checkValidAmount++
                    }
                });
                var formOneFieldsAmount = this.$el.querySelectorAll(`#form-one [data-vv-as]:not([data-vv-as=''])`).length;
                var formTwoFieldsAmount = this.$el.querySelectorAll(`#form-two [data-vv-as]:not([data-vv-as=''])`).length;
                var formThreeFieldsAmount = this.$el.querySelectorAll(`#form-three [data-vv-as]:not([data-vv-as=''])`).length;
                var formFourFieldsAmount = this.$el.querySelectorAll(`#form-four [data-vv-as]:not([data-vv-as=''])`).length;
                let progress;
                switch(this.formStep){
                    case 0:
                        var percent = checkValidAmount / formOneFieldsAmount;
                        this.progressValue = `calc(${((percent*25).toString())}% + 12.5px)`;
//                        console.log(checkValidAmount / formOneFieldsAmount);
                        break;
                    case 1:
                        var percent = checkValidAmount / (formOneFieldsAmount + formTwoFieldsAmount);
//                        if(((percent*50).toString()) <= 25){
//                            this.progressValue = `calc(25% + 12.5px)`;
//                        }else{
                            this.progressValue = `calc(${((percent*50).toString())}%)`;
//                        }
                        break;
                    case 2:
                        var percent = checkValidAmount / (formOneFieldsAmount + formTwoFieldsAmount + formThreeFieldsAmount);
                        if(((percent*75).toString()) <= 52 /* 52 come from 50% + 6.25px */){
                            this.progressValue = `50%`;
                            this.progressValue = `calc(${((percent*75).toString())}%)`;
                        }else{
                            this.progressValue = `calc(${((percent*75).toString())}% - 6.25px)`;
                        }
                        break;
                    case 3:
                        var percent = checkValidAmount / (formOneFieldsAmount + formTwoFieldsAmount + formThreeFieldsAmount + formFourFieldsAmount);
//                        if(((percent*100).toString()) <= 73){
//                            this.progressValue = `calc(75% - 6.25px)`;
//                        }else{
                            this.progressValue = `calc(${((percent*100).toString())}%)`;
//                        }
                        break;
                }
            }
        },
        mounted: function(){
            this.changeProgressPercentage();
        }
    }
</script>


<style lang="scss">
    .ui {
        position: relative;
    }

    $max-container-width: 1240px;
    $lightTopProgressBarGradient: linear-gradient(to right, rgb(148, 232, 247), rgb(6, 85, 140));
    $darkSideProgressBarGradient: linear-gradient(to bottom, rgb(9, 139, 174), rgb(6, 85, 140));
    $sideItemGrey: rgb(77, 77, 77);
    $stepBgColor: #203540;
    $themeColor: rgb(9, 139, 174);
    #mobile-progress-bar {
        position: fixed;
        z-index: 100;
        background: white;
        width: 100%;
        max-width: $max-container-width;
        height: 5px;
        display: none;
    }

    #mobile-progress-bar>div {
        background: $lightTopProgressBarGradient;
        height: 100%;
        width: 10%;
        /* will calc by script */
    }

    #close-btn {
        width: 50px;
        height: 50px;
        border-radius: 0 0 40px 0;
        background: $themeColor;
        position: fixed;
        cursor: pointer;
        z-index: 90;
    }

    #close-btn>div {
        width: 25px;
        height: 6px;
        background: white;
        position: absolute;
        border-radius: 5px;
    }

    #close-btn>div:first-child {
        transform: rotate(45deg);
        top: 20px;
        left: 10px;
    }

    #close-btn>div:last-child {
        transform: rotate(-45deg);
        top: 20px;
        left: 10px;
    }

    section.container {
        display: table;
        width: 100%;
        height: 100%;
        background: white;
    }

    .form-container {
        display: table-cell;
        width: calc(100% - 350px);
        vertical-align: top;
    }

    .step-container {
        max-width: 350px;
        width: 350px;
        height: 100vh;
        display: table-cell;
        vertical-align: top;
        overflow: hidden;
        user-select: none;
    }

    #normal-step {
        right: 0;
        width: 100%;
        max-width: 350px;
        min-width: 180px;
        height: 100%;
        background: $stepBgColor;
    }

    #normal-step>div {
        position: fixed;
        height: 325px;
        width: 350px;
        background: $sideItemGrey;
    }

    #normal-step-progress {
        min-height: 12.5px;
        max-height: 325px;
        background: $darkSideProgressBarGradient;
        position: absolute;
        width: 100%;
    }

    #normal-step .step-item {
        box-sizing: content-box;
        height: 75px;
        line-height: 75px;
        color: rgba(255, 255, 255, 0.6);
        font-size: 24px;
        text-align: left;
        padding-left: 10px;
        position: relative;
        z-index: 10;
        white-space: nowrap;
    }

    .step-item.valid {
        cursor: pointer;
    }

    #normal-step .step-item img {
        width: 50px;
        vertical-align: middle;
    }

    #normal-step .step-item span {
        padding-left: 5px;
    }

    #normal-step .step-item:nth-child(2) {
        padding-top: 12.5px;
    }

    #normal-step .step-item:last-child {
        padding-bottom: 12.5px;
    }

    #next-btn {
        width: 350px;
        height: 75px;
        position: fixed;
        line-height: 75px;
        bottom: 0;
/*        transform: translateY(-100%);*/
        background: $sideItemGrey;
        color: white;
        font-size: 24px;
        cursor: pointer;
    }

    #mobile-step {
        display: none;
    }

    form {
        width: 100%;
        padding: 0 50px;
        box-sizing: border-box;
        overflow: hidden;
    }

    @media screen and (max-width: 920px) {
        .form-container {
            width: 100%;
        }
        .step-container {
            min-width: 180px;
            width: auto;
        }
        #normal-step {
            width: 180px;
        }
        #normal-step>div{
            width: 180px;
        }
        #normal-step>div:hover {
            width: 350px;
            right: 0;
        }
        #normal-step>div:hover>.step-item {
            text-align: left;
            padding-left: 10px;
        }
        #normal-step>div:hover>.step-item span {
            display: inline-block;
        }
        #normal-step .step-item {
            text-align: center;
            padding-left: 0;
        }
        #normal-step .step-item span {
            display: none;
        }
        #next-btn {
            width: 180px;
        }
    }

    @media screen and (max-width:640px) {
        #mobile-progress-bar {
            display: block;
        }
        .mobile-current-step {
            width: 50px;
            height: 50px;
            cursor: pointer;
        }
        .mobile-current-step>img {
            width: 30px;
            height: 30px;
            padding: 10px;
        }
        #normal-step {
            display: none;
        }
        #mobile-step {
            display: block;
        }
        .mobile-current-step.active ~ .mobile-step-list-container{
            display: block;
        }
        .mobile-step-list-container {
            display: none;
            background: $stepBgColor;
            position: fixed;
            bottom: 50px;
            color: rgba(255,255,255,0.6);
            width: 240px;
            height: 200px;
            text-align: left;
        }
        #mobile-step .step-item{
            height: 50px;
            line-height: 50px;
            padding: 0 10px;
            font-size: 16px;
        }
        #mobile-step .step-item.active{
            background: $themeColor;
        }
        #mobile-step .step-item img {
            width: 30px;
            vertical-align: middle;
        }

        #mobile-step .step-item span {
            padding-left: 5px;
        }
        #mobile-step-list-cancel-bg{
            position: fixed;
            height: 100vh;
            width: 100vw;
            z-index: -1;
            top: 0;
            cursor: pointer;
        }
        .form-container {
            display: block;
            width: 100%;
        }
        .step-container {
            display: block;
            width: 100%;
            height: 50px;
            position: fixed;
            max-width: none;
            bottom: 0;
            background: $stepBgColor;
            z-index: 10;
        }
        #next-btn {
            width: calc(100% - 50px);
            position: fixed;
            height: 50px;
            line-height: 50px;
            right: 0;
            transform: translateY(0);
        }
    }

</style>
